// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'state' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/**
 * @typedef {'insurance-facility'|'insurance-doctor'|'insurance-patient'|'corporate-partner-facility'|'corporate-partner-patient'} InsuranceContractType
 */

/**
 * @typedef {Object} Organization
 * @property {string} id
 * @property {string} name
 * @property {string} logoURL
 * @property {string} picURL
 * @property {string} coverURL
 */

/**
 * @typedef {Object} InsuranceContract
 * @property {string} id
 * @property {number} createdAt
 * @property {string} createdBy
 * @property {InsuranceContractType} type
 * @property {string} insured facility id for facility contract, doc id for private doctors
 * @property {Organization} insurer for insurance companies, the insurance company id; for coroporate partnership, same as id
 * @property {string} insurerSubtype
 * @property {string} insurerPicURL
 * @property {string} insurerName
 * @property {string} insurerDescription
 * @property {string} label label
 * @property {string} destructionInitiator insurer/insured that initiated the destruction of contract. cantract can only be destroyed upon agreement of insurer and insured
 * @property {number} expiresAt expiration
 * @property {number} startAt start
 * @property {number} endAt end
 * @property {Object.<string,any>} meta
 */

const state = {
  /** @type {InsuranceContract[]} */
  contracts: []
};

export default state;

/**
 * @param {state} state
 * @returns {InsuranceContract[]}
 */
export function companyContracts (state) {
  return state.contracts
    .filter(c => c.type === 'corporate-partner-facility')
    .map(c => ({ ...c, insurer: c.insurerCompany }));
}

/**
 * @param {state} state
 * @returns {InsuranceContract[]}
 */
export function hmoContracts (state) {
  return state.contracts.filter(c => c.type === 'insurance-facility' && c.insurerSubtype === 'hmo');
}

/**
 * @param {state} state
 * @returns {InsuranceContract[]}
 */
export function governmentContracts (state) {
  return state.contracts.filter(c => c.type === 'insurance-facility' && c.insurerSubtype === 'government');
}
